import { useSelector } from "react-redux";

import { getCurrentUserId, getNhDealApplicationId, getSelfReferralInSession } from "features/authSlice";
import { useGetDashboardItemsQuery, dashboardApi } from "pages/dashboard/home/dashboardService";
import { useUqualVisibilityFlags } from "hooks/useUqualVisibilityFlags";
import { AppDispatch } from "store";

interface UseUqualReferralStateOptions {
  skipQuery?: boolean;
}

export const useUqualReferralState = (options: UseUqualReferralStateOptions = {}) => {
  const { skipQuery = false } = options;
  const userId = useSelector(getCurrentUserId);
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const selfReferralInSession = useSelector(getSelfReferralInSession);

  const querySkipped = skipQuery || !nhDealApplicationId || !userId;

  const { showUqualBanner, showUqualNotification } = useUqualVisibilityFlags({
    skipQuery: querySkipped,
  });

  const { data: dashboardData } = useGetDashboardItemsQuery(
    { dealApplicationId: nhDealApplicationId, userId: userId ?? "" },
    { skip: querySkipped },
  );

  const isUqualReferralComplete =
    selfReferralInSession || dashboardData?.isUqualSelfReferralDone === true;

  return {
    showUqualBanner,
    showUqualNotification,
    isUqualReferralComplete,
    effectiveShowBanner: showUqualBanner && !isUqualReferralComplete,
    effectiveShowNotification: showUqualNotification && !isUqualReferralComplete,
    effectiveShowHomeCard: !isUqualReferralComplete,
  };
};

export const syncUqualDashboardAfterReferral = (
  dispatch: AppDispatch,
  _nhDealApplicationId: string,
  _userId: string,
) => {
  dispatch(dashboardApi.util.invalidateTags(["dashboard"]));
};
